import { Spinner } from "@design";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router";
import { chatAccessShareLinkOptions } from "@/api";
import { Text } from "@/components/Text";
import { ThreadColumn } from "./ChatMessages";

/** `/chat/shared/:token`: resolves a share link and opens the chat it points to. */
export function SharedChatLinkPage() {
  const { t } = useTranslation("chat", { keyPrefix: "share" });
  const { token = "" } = useParams();
  const link = useQuery({ ...chatAccessShareLinkOptions({ path: { token } }), select: (r) => r.data });
  if (link.data) return <Navigate to={`/chat/${link.data.uuid}`} replace />;
  return (
    <ThreadColumn>
      {link.isError ? (
        <>
          <Text variant="h2" as="h1">
            {t("linkInvalidTitle")}
          </Text>
          <Text tone="secondary">{t("linkInvalidSubtitle")}</Text>
        </>
      ) : (
        <div className="flex justify-center py-12">
          <Spinner size="md" aria-label={t("opening")} />
        </div>
      )}
    </ThreadColumn>
  );
}
